/* ==========================================================================
# Scroll Top Button functionality
========================================================================== */

const initScrollTopBtn = () => {
  const scrollTopBtn = document.querySelector("[data-scroll-top-btn]");
  if (!scrollTopBtn) return;
  scrollTopBtn.addEventListener("click", () =>
    window.scrollTo({ top: 0, behavior: "smooth" })
  );
  window.addEventListener("scroll", () =>
    window.scrollY > 1000
      ? scrollTopBtn.classList.remove("hidden")
      : scrollTopBtn.classList.add("hidden")
  );
};
initScrollTopBtn();
